import { useCallback, useState } from 'react';
import head from 'lodash/head';

export const ALLOWED_FORMAT = ['image/jpg', 'image/jpeg', 'image/png'];

export function useFileManagement() {
  const [file, setFile] = useState();

  const handleFileChange = useCallback(
    e => {
      const selectedFile = head(e.target.files);
      const reader = new FileReader();

      if (!selectedFile) {
        return setFile(undefined);
      }

      if (!ALLOWED_FORMAT.includes(selectedFile.type)) {
        return;
      }

      reader.addEventListener('load', () => setFile(reader.result));
      reader.readAsDataURL(selectedFile);
    },
    [setFile],
  );

  return [file, setFile, handleFileChange];
}



// WEBPACK FOOTER //
// ./src/components/common/ImageManager/utils.js